export const COPILOT_STEPS = [
  { id: 1, title: 'Order & Product Confirmation' },
  { id: 2, title: 'Complaint Identification' },
  { id: 3, title: 'Verification' },
  { id: 4, title: 'Resolution' },
];

export const STEP_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

// Verification checklist copy, matching the Figma spec exactly.
export const VERIFICATION_CHECKLIST_ITEMS = [
  {
    id: 'full-product-visible',
    label: 'The image has the full product and its name clearly visible',
  },
  {
    id: 'variant-visible',
    label: 'The Shade/Variant/Product Code (if applicable) is visible',
  },
  {
    id: '360-view',
    label: 'A 360 degree view of the product is visible',
  },
  {
    id: 'seal-condition',
    label:
      'Inspect the seal condition - signs of tampering or repasting or no seal at all',
  },
];

// TEMPORARY mock data so steps 2-4 can be reviewed/built against without
// first running the full step-1 flow against a live order. Remove once
// CopilotView threads real confirmed-product/complaint data end to end.
export const MOCK_PRODUCTS = [
  {
    id: 'mock-product-1',
    imageUrl: null,
    name: 'Maybelline New York Sensational Liquid Matte Lipstick - Soft Wine 02',
    quantityLabel: '10 ml',
    count: 1,
    maxCount: 4,
  },
];

export const MOCK_UPLOADED_IMAGES = [
  { id: 'mock-image-1', url: null, type: 'image', alt: 'Uploaded evidence 1' },
  { id: 'mock-image-2', url: null, type: 'image', alt: 'Uploaded evidence 2' },
  { id: 'mock-image-3', url: null, type: 'image', alt: 'Uploaded evidence 3' },
];
